__turbopack_context__.v({
  "button": "need-auth-button-module-scss-module__-_W7IG__button",
});
